import { rankingData } from '@/mocks/homeData';

export default function RankingSection() {
  const getTrendIcon = (trend: string) => {
    if (trend === 'up') return 'ri-arrow-up-line text-accent-600';
    if (trend === 'down') return 'ri-arrow-down-line text-foreground-400';
    return 'ri-subtract-line text-foreground-400';
  };

  const getRankStyle = (rank: number) => {
    if (rank === 1) return 'bg-accent-500 text-background-50';
    if (rank === 2) return 'bg-accent-400 text-background-50';
    if (rank === 3) return 'bg-accent-300 text-background-50';
    return 'bg-background-200 text-foreground-600';
  };

  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            热门排行
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            全网最热漫画人气榜单
          </p>

          <div className="mt-10 max-w-2xl mx-auto">
            <div className="space-y-3">
              {rankingData.map((item) => (
                <a
                  key={item.id}
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="group flex items-center gap-4 p-4 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
                >
                  <span
                    className={`w-9 h-9 rounded-lg flex items-center justify-center text-sm font-heading shrink-0 ${getRankStyle(item.rank)}`}
                  >
                    {item.rank}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                        {item.title}
                      </span>
                      <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-1.5 shrink-0">
                    <i className={`text-sm ${getTrendIcon(item.trend)}`}></i>
                    <span className="text-sm font-semibold text-foreground-700 whitespace-nowrap">
                      {item.heat}
                    </span>
                  </div>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}